module.exports = __webpack_public_path__ + "img/message-code.7e11ec03.svg";